import { Link } from 'react-router-dom';
import { ArrowRight, Mail, Car } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import '../AllCss/InfoPage.css';

const PAGE_KEYS = ['about', 'blog', 'shipping', 'warranty', 'returns'];

export function isInfoPageKey(key) {
  return PAGE_KEYS.includes(key);
}

function InfoPage({ pageKey }) {
  const { t } = useLocale();
  const title = t(`infoPages.${pageKey}.title`);
  const subtitle = t(`infoPages.${pageKey}.subtitle`);
  const body = t(`infoPages.${pageKey}.body`);
  const showGrowthLinks = pageKey === 'blog';

  return (
    <div className="InfoPage">
      <Navbar />
      <section className="InfoPage-hero">
        <div className="container">
          <h1 className="InfoPage-title">{title}</h1>
          <p className="InfoPage-subtitle">{subtitle}</p>
        </div>
      </section>
      <section className="InfoPage-content">
        <div className="container">
          <div className="InfoPage-card">
            <p className="InfoPage-body">{body}</p>
            <div className="InfoPage-actions">
              {showGrowthLinks && (
                <>
                  <Link to="/inventory" className="InfoPage-cta InfoPage-cta-secondary">
                    <Car size={20} />
                    <span>{t('footer.browseInventory')}</span>
                    <ArrowRight size={18} />
                  </Link>
                  <Link to="/auth?mode=register" className="InfoPage-cta InfoPage-cta-secondary">
                    <span>{t('auth.createAccount')}</span>
                    <ArrowRight size={18} />
                  </Link>
                </>
              )}
              <Link to="/contact" className="InfoPage-cta">
                <Mail size={20} />
                <span>{t('infoPages.contactCta')}</span>
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default InfoPage;
